import React from "react"
import { HistoricoVersoesInicial } from "../models/historicoVersoesModel"
import { HistoricoVersoesContext } from "./HistoricoVersoesContext"

type HistoricoVersoesContextProviderProps = {
    children: React.ReactNode
}

export function HistoricoVersoesContextProvider({
    children,
}: HistoricoVersoesContextProviderProps) {
    return (
        <HistoricoVersoesContext.Provider
            value={{ historico: HistoricoVersoesInicial, dispatch: () => {}, erroCarregamento: null }}
        >
            {children}
        </HistoricoVersoesContext.Provider>
    )
}
